import { Modal, type WrappedButtonProps } from '@socrait/react';

type SaveChangesModal = {
  isOpen: boolean;
  onCloseModal: () => void;
  onCloseEdit: () => void;
  onSave: () => void;
};

export function SaveChangesModal({ isOpen, onCloseModal, onCloseEdit, onSave }: SaveChangesModal) {
  const buttons: WrappedButtonProps[] = [
    {
      name: 'Leave Page',
      onPress: onCloseEdit,
    },
    {
      name: 'Save',
      onPress: onSave,
      variant: 'primary',
    },
  ];

  return (
    <Modal
      title={'Save Changes?'}
      content={'Looks like you have unsaved changes on this page.'}
      buttons={buttons}
      modalVisible={isOpen}
      handleClose={onCloseModal}
      buttonLayout="row"
    />
  );
}
